$(function(){
     $('.u_hamberger,.u_mb_menu_overlay').click(function(){
    $('.u_hamberger').toggleClass('change');
    $('.u_mobile_menu').toggleClass('active');
    $('.u_hamberger .u_berger_line:last-child').toggleClass('u_burger_width');
    $('body').toggleClass('overflow');     
  });
  $('.u_navbar_item_link_mb').click(function(){
    $(this).toggleClass('u_mb_active_title');
    $(this).parent().find('i').toggleClass('fa-plus fa-minus');
    $(this).parent().parent().find('.u_sec_dropdown_mb').slideToggle();
  })
   $('.u_accordian_head').click(function(){               
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
     $(this).find('.u_icon').addClass('plus').removeClass('minus');
                }
                else{
            $(this).next('.u_accordian_body').addClass('active').slideDown();
   $(this).find('.u_icon').addClass('minus').removeClass('plus');
                }
            })      
   $(document).on('click','.u_accordians_head',function(){
    $('.announcement-section,#shopify-section-header').addClass('u_active_sizepopup')
     $(this).next('.u_accordian_body').show();
       $('.u_sizechat_popup_block').show();
       $('html').attr('style','overflow:hidden')
        // $('html, body').scrollTop(0);
    })
     $('.u_sizechart_pop_up_overlay').click(function(){
          $('.announcement-section,#shopify-section-header').removeClass('u_active_sizepopup')
     $(this).closest('.u_accordian_body').hide();
       $('.u_sizechat_popup_block').hide();
              $('html').attr('style','overflow:auto')
    })
})